import React, { useState } from "react";

import { viewerWidth, contentWidth, viewerMode, mobileView, isArabic } from '../global';
import Master from "./Master"
import andImg from "../images/android.png";
import iosImg from "../images/ios.png";
import mockup from "../images/mockup.png";
import mockup1 from "../images/mockup1.png";
import mockup2 from "../images/mockup2.png";
import mockup3 from "../images/mockup3.png";
import mockup4 from "../images/mockup4.png";
import avatarWhoWeAre from "../images/avatar_whoweare.png";
import avatarContactus from "../images/avatar_contactus.png";
import icon1_off from "../images/1_off.svg";
import icon1_on from "../images/1_on.svg";
import icon2_off from "../images/2_off.svg";
import icon2_on from "../images/2_on.svg";
import icon3_off from "../images/3_off.svg";
import icon3_on from "../images/3_on.svg";
import icon4_off from "../images/4_off.svg";
import icon4_on from "../images/4_on.svg";
import rest1 from '../images/rest1.svg';
import rest2 from '../images/rest2.png';
import rest3 from '../images/rest3.png';
import rest4 from '../images/rest4.png';
import rest5 from '../images/rest5.svg';
import email from '../images/email.svg'
import underscore from '../images/underscore.svg';
import arrow_right from '../images/arrow_right.svg'
import arrow_left from '../images/arrow_left.svg'
import longPipe from "../images/long_pipe.png";

import "../styles/global.css";
import "./styles.css"



const Home = () => {
  return (
    <Master root='' withBG={true}  >
      <Intro /> <br /><br />
      <OurList /> <br /><br />
      <HowItWorks /> <br /><br />
      <Register /> <br /><br/>
      <JoinUs /> <br /><br />
      <ContactUs /> <br /><br />
    </Master>
  );
};

const Intro = () => {

  const header1Str = isArabic ? 'تطبيق جمهور هب بضغطة زر':'JamhoorHub App with one click'
  const header2Str = isArabic ? 'و وجبتك في':'your meal is at the'
  const staduimStr = isArabic ? 'الملعب':'Stadium'
  const subheader1Str = isArabic ? 'استمتع بكل لحظة في المباراة مع جمهور هب':'Enjoy every moment of the match with Jamhoorhub'
  const subheader2Str = isArabic ? 'خدمة توصيل الطعام إلى مقاعد الملاعب':'Food delivery service to stadium seats'
  const whoWeAreStr = isArabic ? 'من نحن':'Who We Are'
  const whoWeAre2Str = isArabic ? 'جمهور هب هي أول خدمة توصيل طعام داخل الملعب في السعودية، مصممة لجعل تجربة فعالياتك الرياضية ممتعة قدر الإمكان.':'Jamhoorhub is the first in-stadium food delivery service in Saudi Arabia, designed to make your sporting event experience as enjoyable as possible.'


  const underScoreSize = 70 + ((viewerMode-1)*15)

  const slogan = (
    <section className="Column ">
      <div className="SloganHeader">{header1Str}</div>
      <section className="Row">
        <div className="SloganHeader">{header2Str}&nbsp;</div>
        <section className="Column">
          <div className="SloganHeader Orange">{staduimStr}</div>
          <img src={underscore} width={underScoreSize}/>
        </section>
      </section>
      <br />
      <div className="SloganSubHeader">{subheader1Str}</div>
      <div className="SloganSubHeader">{subheader2Str}</div>
    </section>
  )
  
  const whoWeAre = (
    <section className="Column" >
      <div className="Header">{whoWeAreStr}</div>
      <div className="SubHeader">{whoWeAre2Str}</div>
    </section>
  )


  const storeLinks = (
    <section className="Row">
      <a href="https://play.google.com/store/apps/details?id=com.jamhoorhub.jamhoorhub"><img src={andImg} width={viewerMode==1?'120px':"150px"} /></a>
      &nbsp;&nbsp;
      <a href="https://apps.apple.com/sa/app/id6502456473"><img src={iosImg} width={viewerMode==1?'120px':"150px"} /></a>
    </section>
  )
  

  if (mobileView)
    return (
      <div className="content">
      <section className="Column CrossCenter" >
        {slogan} <br /><br />
        {storeLinks} <br/><br/>
        <img src={mockup} width={viewerMode<=2?'70%':'50%'}/>
        <div id="whoweare"></div>{whoWeAre}
        <img  src={avatarWhoWeAre} width={viewerMode==3?'70%':'100%'}/>
      </section>
      </div>
    )
  else
    return (
      <div className="content">
      <section className="Row CrossStart">
        <section className="Column Flex60 CrossStart" >
          <br /><br /><br /><br />
          {slogan}  <br /><br />
          {storeLinks}  <br /><br /><br /><br /><br/>
          <img id="whoweare" src={avatarWhoWeAre} width="80%" />
        </section>
        <section className="Column Flex40 CrossCenter">
          <img src={mockup} width='80%'/>
          <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
          {whoWeAre}
        </section>
      </section>
      </div>
    )
}

const OurList = () => {

  const ourListStr = isArabic ? 'قائمتنا':'Our List'
  const ourList2Str = isArabic ? 'من كوب الذرة الكلاسيكي إلى السندويشات الذواقة، لدينا كل شيء! نتعاون مع الجميع لنقدم لك الأفضل':'From classic corn cobs to gourmet sandwiches, we have it all! We work with everyone to bring you the best.'
  
  return (
    <div className="content">
      <div className="BoxOrange">
        <section className="Column CrossCenter">
          <br/>
          <div className="Header White">{ourListStr}</div>
          <div className="SubHeader White Padding5 Center">{ourList2Str}</div>
          <br/>
          <section className="Row CrossCenter Expand MainSpaceBetween">
            <div className="Padding1"></div><img src={isArabic?arrow_right:arrow_left}/><div className="Padding1"></div>
            <section className="Column BoxGradient Expand">
              <br/>
              <section className="Row CrossCenter MainSpaceEvenly Expand">
                <img src={rest1} width={mobileView?'20%':'100px'}/>
                <img src={rest2} width={mobileView?'20%':'100px'}/>
                <img src={rest3} width={mobileView?'20%':'100px'}/>
                {!mobileView? <img src={rest4} width='100px'/>:<></>}
                {!mobileView? <img src={rest5} width='100px'/>:<></>}
              </section>
              <br/>
            </section>
            <div className="Padding1"></div><img src={isArabic?arrow_left:arrow_right}/><div className="Padding1"></div>
          </section>
          <br/><br/>
        </section>
      </div>
    </div>
  )
}

const StepWidget = (props) => {
  const step = props.step
  const conf = props.conf
  const iconOn = props.iconOn;
  const iconOff = props.iconOff;
  const title = props.title
  const subtitle = props.subtitle
  const onClick = props.onClick
  const onMouseEnter = props.onMouseEnter
  const onMouseLeave = props.onMouseLeave

  const size1 = mobileView?'50px':'70px'
  const size2 = mobileView?'25px':'30px'
  const shift = mobileView?'12.5px':'20px'

  const ss='72px';

  var onClasses = "StackItem ";
  onClasses += conf.on? "Show ":"Fade ";
  if (conf.animate) onClasses += "AnimatedImage "

  var offClasses = "StackItem ";
  offClasses += !conf.on? "Show ":"Fade ";
  if (conf.animate) offClasses += "AnimatedImage "

  
  return (
    <section className="Row CrossCenter">
      <div style={{ height: size1, width: size1 }}>
        <div className="Stack Pointer" style={{ height: size1, width: size1 }} onClick={() => onClick(step)} onMouseEnter={() =>onMouseEnter(step)} onMouseLeave={() => onMouseLeave(step)}> 
          <img className={onClasses} src={iconOn} width={size1} height={size1} />
          <img className={offClasses} src={iconOff} width={size1} height={size1} />
        </div>
      </div>
      {/* <section className="Stack Pointer" style={{ height: size1, width: size1 }} onClick={() => onClick(step)} onMouseEnter={() =>onMouseEnter(step)} onMouseLeave={() => onMouseLeave(step)}>
        <div className={stepObj.animate ? "StackItem Animate" : "StackItem"} > <img src={stepObj.icon_back} width={size1} height={size1} /></div>
        <div className="StackItem" style={{ top: shift, right: shift }}><img src={stepObj.icon} width={size2} height={size2} /></div>
      </section> */}
      <div className="">&nbsp;</div>
      <div className="StepHeader " >{step}</div>
      <div className="">&nbsp;</div>
      <div className="VerticalDivider"/>
      <div>&nbsp;</div>
      <section className="">
        <div className="SubHeader Bold">{title}</div>
        <div className="SubHeader">{subtitle}</div>
      </section>
    </section>
  )
}

const HowItWorks = () => {

  const howItWorksStr = isArabic ? 'كيف يعمل ؟':'How It Works?'
  const step1Str = isArabic ? 'اختر الفعالية':'Select the Event'
  const step1SubStr = isArabic ? 'اختر المباراة التي ستحضرها على تطبيقنا':'Choose the match you will attend on our app'
  const step2Str = isArabic ? 'اختر وجبتك المفضلة':'Choose your Favorite Meal'
  const step2SubStr = isArabic ? 'تصفح قائمة واسعة من الأطعمة والمشروبات في الملعب':'Browse an extensive menu of food and beverages at the stadium.'
  const step3Str = isArabic ? 'قم بالطلب':'Place an Order'
  const step3SubStr = isArabic ? 'ضف العناصر إلى عربة التسوق وأكمل عملية الشراء بسهولة':'Add items to your cart and complete your purchase easily.'
  const step4Str = isArabic ? 'استمتع بالمباراة':'Enjoy the Game'
  const step4SubStr = isArabic ? 'سيقوم الجمهورجي بتوصيل طلبك مباشرة إلى مقعدك':'The jamhoorgy will deliver your order directly to your seat.'

  const [step1Conf, setStep1Conf] = useState({on: true, animate:false});
  const [step2Conf, setStep2Conf] = useState({on: false, animate:false});
  const [step3Conf, setStep3Conf] = useState({on: false, animate:false});
  const [step4Conf, setStep4Conf] = useState({on: false, animate:false});
  const [animate, setAnimate] = useState(false);
  const [curStep, setCurStep] = useState(1);
  const [curMockup, setCurMockup] = useState(mockup1);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  async function onCLick(step)  {
    if (curStep == step) return;
    if (step != 1) setStep1Conf({on: false, animate:true});
    if (step != 2) setStep2Conf({on: false, animate:true});
    if (step != 3) setStep3Conf({on: false, animate:true});
    if (step != 4) setStep4Conf({on: false, animate:true});
    
    if (step == 1) {
      setCurMockup(mockup1);
      setStep1Conf({on: false, animate:false});
      await delay(10);
      setStep1Conf({on: true, animate:true});
    }
    if (step == 2) {
      setCurMockup(mockup2);
      setStep2Conf({on: false, animate:false});
      await delay(10);
      setStep2Conf({on: true, animate:true});
    }
    if (step == 3) {
      setCurMockup(mockup3);
      setStep3Conf({on: false, animate:false});
      await delay(10);
      setStep3Conf({on: true, animate:true});
    }
    if (step == 4) {
      setCurMockup(mockup4);
      setStep4Conf({on: false, animate:false});
      await delay(10);
      setStep4Conf({on: true, animate:true});
    }

    setCurStep(step);    
  };

  function onMouseEnter(step){
    if (step == 1) setStep1Conf({on: true, animate:false});
    if (step == 2) setStep2Conf({on: true, animate:false});
    if (step == 3) setStep3Conf({on: true, animate:false});
    if (step == 4) setStep4Conf({on: true, animate:false});
  }

  function onMouseLeave(step){
    if (curStep == step) return
    if (step == 1) setStep1Conf({on: false, animate:false});
    if (step == 2) setStep2Conf({on: false, animate:false});
    if (step == 3) setStep3Conf({on: false, animate:false});
    if (step == 4) setStep4Conf({on: false, animate:false});
  }

  const shiftTop = mobileView?'50px':'70px'
  const shiftRight = isArabic?(mobileView?25:35):0
  const shiftLeft = isArabic?0:(mobileView?25:35)

  var pipeHeight = '280px';
  if (viewerMode==4) pipeHeight = '280px';
  if (viewerMode==3) pipeHeight = '260px';
  if (viewerMode==2) pipeHeight = '260px';
  if (viewerMode==1) pipeHeight = '250px';
  // mobileView?(viewerMode==3?viewerWidth*0.8*0.7:viewerWidth*0.8):'500px'
  
  return (
    <div className="content">
      <section className={mobileView ? "Column CrossCenter" : "Row MainSpaceEvenly CrossStart"} id="howitworks" style={{height:!mobileView?contentWidth/2:''}}>
        <div className={mobileView?"Stack":"Stack Flex50"} style={{ height: mobileView?(viewerMode==3?viewerWidth*0.8*0.7:viewerWidth*0.8):'600px', width:viewerMode==3?'70%':'100%'}}>
        <img className={"StackItem AnimatedImage "+(curMockup==mockup1?'Show':'Fade')} src={mockup1} width='100%'  />
        <img className={"StackItem AnimatedImage "+(curMockup==mockup2?'Show':'Fade')} src={mockup2} width='100%'  />
        <img className={"StackItem AnimatedImage "+(curMockup==mockup3?'Show':'Fade')} src={mockup3} width='100%'  />
        <img className={"StackItem AnimatedImage "+(curMockup==mockup4?'Show':'Fade')} src={mockup4} width='100%'  />
        </div>
        <div className={mobileView?"":'Flex50'}>
          <section className='Column'>
            <div className="Header">{howItWorksStr}</div>
            <section className="Stack" style={{ width: "100%"}}>
              <div className="StackItem" style={{ top: shiftTop, right: shiftRight, left: shiftLeft }}><img src={longPipe} height={pipeHeight} /></div>
              {/* <section className="Column StackItem"> */}
              <br/><StepWidget step='1' conf={step1Conf} iconOn={icon1_on} iconOff={icon1_off} title={step1Str} subtitle={step1SubStr} onClick={onCLick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}  />
              <br/><StepWidget step='2' conf={step2Conf} iconOn={icon2_on} iconOff={icon2_off} title={step2Str} subtitle={step2SubStr} onClick={onCLick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}  />
              <br/><StepWidget step='3' conf={step3Conf} iconOn={icon3_on} iconOff={icon3_off} title={step3Str} subtitle={step3SubStr} onClick={onCLick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}  />
              <br/><StepWidget step='4' conf={step4Conf} iconOn={icon4_on} iconOff={icon4_off} title={step4Str} subtitle={step4SubStr} onClick={onCLick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}  />
              {/* </section> */}
            </section>
          </section>
        </div>
      </section>
    </div>
  );
}

const Register = () => {

  const [inputEmail, setInputEmail] = useState('');
  const [code, setCode] = useState('');
  const [response, setResponse] = useState('');

  const handleSubmit = async () => {

    setCode('');
    const email = inputEmail.trim();
    
    if (!email){
      setResponse(isArabic?'الرجاء املأ جميع الحقول': 'Please fill all fields');
      return;
    }

    setResponse('sending');

    try {
      const res = await fetch(`https://jamhoorhub.com/app_dev/register?email=${email}`, {
        method: 'GET',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8', 
        // },
        // body: JSON.stringify(data), 
      });

      if (res.ok) {
        const responseData = await res.json(); 
        setInputEmail('');
        setCode(responseData.data);
        setResponse('ok');
      } else {
        console.error('Request failed', res);
        const errorMessage = await res.text();
        setResponse(`ERROR: ${response.status} - ${errorMessage}`);
      }
    } catch (error) {
      console.error('Error:', error);
      setResponse(error.message);
    }
  };



  const registerStr = isArabic ? 'سجل ايميلك وخلي أول توصيل علينا':'Register your email to get a free first-time delivery'
  const emailStr = isArabic ? 'البريد الالكتروني':'Email';
  const sendStr = isArabic ? 'ارسل كود الخصم':'Send Discount Code';
  const confirmStr = isArabic ? `بإمكانك استخدام كود الخصم ${code} وتمتع بأول توصيل مجاني`:`Use the discount code ${code} and enjoy first-time delivery free.`
  const sendingStr = isArabic ? 'يتم الإرسال...':'Sending...'

  const width = mobileView?'100%':'300px'
  
  return (
    <div className="content">
      <div className="Padding10">
    <section className='Row '>
      <div className="Column CrossCenter Box" style={{flex:8}}>
        <br/>
        <div className="Header">{registerStr}</div>
        <br/>
        <section className={mobileView?"Expand":''}>
          <section className={mobileView?"Padding10":''}>
            <section className="Column CrossCenter">
              <section className={mobileView?'Column CrossEnd Expand':'Row CrossCenter'}>
                <section className={mobileView?"Row Expand":'Row'}><input name='email' placeholder={emailStr} value={inputEmail} style={{width:width}} onChange={(e)=> setInputEmail(e.target.value)}  />{mobileView?<></>:<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>}</section>
                <div className="Button" onClick={handleSubmit}>{sendStr}</div>
              </section>
              {/* <div className="SubHeaderSmall">{showCode>0?confirmStr:''}</div> */}
              <br/>
              <div className="SubHeaderSmall">{response==''?'':(response=='ok'?confirmStr:(response=='sending'?sendingStr:response))}</div>
            </section>
          </section>
        </section>
        <br/>
      </div>
    </section>
    </div>
    </div>
  )
}

const JoinUs = () => {

  const [dummy, setDummy] = useState('');

  const joinUsStr = isArabic ? 'انضم إلينا':'Join Us'
  const joinUsSubStr1 = isArabic ? 'انضم لجمهورهب وكن جزء':'Join JamhoorHub and be a part of'
  const joinUsSubStr2 = isArabic ? 'من تجربة فريدة':'a unique experience'
  const joinUsSubStr3 = isArabic ? 'من داخل الملعب':'from inside the stadium'

  const asJamhoorgyStr = isArabic ? 'كـ جمهورهي':'As Jamhoorgy'
  const asJamhoorgySubStr1 = isArabic ? 'انضم لفريق جمهور هب لتوصيل الطلبات':'Join us to deliver orders'
  const asJamhoorgySubStr2 = isArabic ? 'وكن جزء من تجربة فريدة من داخل الملعب':'and be part of a unique experience from inside the stadium'

  const asVendorStr = isArabic ? 'كـ صاحب محل':'As Vendor'
  const asVendorSubStr1 = isArabic ? 'انضم إلينا لنساعدك للوصول إلى المزيد من':'Join us to help you reach more'
  const asVendorSubStr2 = isArabic ? 'العملاء من داخل مدرجات الملاعب':'customers from inside the stadium stands'

  const joinNowStr = isArabic ? 'انضم الآن':'Join Now'

  
  return (
    <div className={mobileView?'':"content"}>
    <div className='JoinUs' id="joinus" style={isArabic?{}:{transform: 'scaleX(-1)'}}>
      <div className={mobileView?'content':''} style={isArabic?{height:'100%'}:{transform: 'scaleX(-1)', height:'100%'}}>
        <section className="Column" style={{height:'100%'}}>
          <section className={mobileView?'Row CrossEnd Flex Expand70':'Row CrossEnd Flex Expand40'}>
            <section className="Column" >
                <div className="Header">{joinUsStr}</div>
                <img src={underscore} width='80px'/>
                <br/>
                <div className="SubHeader">{joinUsSubStr1} {mobileView?<br/>:<></>}{joinUsSubStr2}{!mobileView?<br/>:<></>} {joinUsSubStr3}</div>
                <br/>
            </section>
          </section>
          <section className={mobileView?(viewerMode==0?"Row CrossEnd Flex Expand40":"Row CrossEnd Flex Expand70"):"Row CrossEnd Flex Expand60"}>
            <section className={mobileView?"Column":'Row'}>
              <section className="Column Flex">
                <div className="SubHeader Bold">{asJamhoorgyStr}</div>
                <div className="SubHeader">{asJamhoorgySubStr1} {asJamhoorgySubStr2}</div>
                <div className="Button" onClick={()=> {window.open('mailto:JamhoorHub <info@jamhoorhub.com>?subject='+(isArabic?'الإنضمام كجمهورجي':'Join As Jamhoorgy')); setDummy('');}}>{joinNowStr}</div>
              </section>
              {mobileView?<div><br /></div>:<div>&nbsp;&nbsp;</div>}
              <section className='Column Flex'>
                <div className="SubHeader Bold">{asVendorStr}</div>
                <div className="SubHeader">{asVendorSubStr1} {asVendorSubStr2}</div>
                <div className="Button" onClick={()=> {window.open('mailto:JamhoorHub <info@jamhoorhub.com>?subject='+(isArabic?'الإنضمام كصاحب محل':'Join As Vendor')); setDummy('');}}>{joinNowStr}</div>
              </section>
            </section>
          </section>
          {/* <br/><br/> */}
        </section>
      </div>
  </div>
  </div>
  );
}

const ContactUs = () => {

  const [response, setResponse] = useState('');
  const [dummy, setDummy] = useState('');
  const [inputName, setInputName] = useState('');
  const [inputEmail, setInputEmail] = useState('');
  const [inputCell, setInputCell] = useState('');
  const [inputMsg, setInputMsg] = useState('');

  const handleSubmit = async () => {

    const name = inputName.trim();
    const email = inputEmail.trim();
    const cell = inputCell.trim();
    const msg = inputMsg.trim();

    if (!name || !email || !cell || !msg){
      setResponse(isArabic?'الرجاء املأ جميع الحقول': 'Please fill all fields');
      return;
    }

    const data = { name: name, email:email, cell:cell, msg:msg };

    setResponse('sending');

    try {
      const res = await fetch('https://jamhoorhub.com/app_dev/contactus', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8', 
        },
        body: JSON.stringify(data), 
      });

      if (res.ok) {
        // const responseData = await res.json(); 
        setInputName('');
        setInputEmail('');
        setInputCell('');
        setInputMsg('');
        // setResponse(responseData.message);
        setResponse('ok');
      } else {
        console.error('Request failed', res);
        const errorMessage = await res.text();
        setResponse(`ERROR: ${response.status} - ${errorMessage}`);
      }
    } catch (error) {
      console.error('Error:', error);
      setResponse(error.message);
    }
  };


  const contactUsStr = isArabic ?'تواصل معنا':'Contact Us'
  const contactUsSubStr1 = isArabic ?'لديك أسئلة أو تحتاج إلى مساعدة؟':'Have questions or need help?'
  const contactUsSubStr2 = isArabic ?'فريق خدمة العملاء لدينا هنا لمساعدتك':'Our customer service team is here to help you'
  const contactUsSubStr3 = isArabic ?'أو تواصل معنا من خلال بريدنا الالكتروني.':'Or contact us through our email.'

  const nameStr = isArabic ?'الاسم':'Name'
  const emailStr = isArabic ?'البريد الالكتروني':'Email'
  const mobileStr = isArabic ?'رقم الجوال':'Mobile No.'
  const msgStr = isArabic ?'اكتب رسالتك...':'Your message...'
  const sendStr = isArabic ?'ارسال':'Send'
  const msgSentStr = isArabic ? 'تشكرك على التواصل معنا. ستقوم بالتواصل معك قريبا.':'Thanks for contacting us. We will contact you soon.'
  const sendingStr = isArabic ? 'يتم الإرسال...':'Sending...'

  
  return (
    <div className="content">
    <section className={mobileView ? "Column" : "Row MainSpaceEvenly"} id="contactus">
      <img className={mobileView?'':"Flex50"}  src={avatarContactus} width={mobileView?'100%':"500px"} />
      <div className={mobileView?"Expand":'Flex50'}>
        <section className='Column'>

          <div className="Header">{contactUsStr}</div>
          
          <section className="Row CrossCenter Expand">
            <div className="VerticalDivider" style={{height:'100px'}} /> &nbsp;
            <section className="Column">
              <div className="SubHeader VMargin">{contactUsSubStr1}</div>
              <div className="SubHeader">{contactUsSubStr2}</div>
              <div className="SubHeader">{contactUsSubStr3}</div>
              <section className="Row VMargin CrossCenter">
                <div className="SubHeader">info@jamhoorhub.com</div>
                &nbsp;
                <img className="Pointer" src={email} width={mobileView?'15px':'30px'} onClick={()=> {window.open('mailto:JamhoorHub <info@jamhoorhub.com>?subject='+(isArabic?'تواصل معنا':'Contact Us')); setDummy('');}}/>
              </section>
            </section>
          </section>

          <div style={{opacity: 0}}>. . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .</div>



          <section className="Column CrossEnd Expand">
            <section className="Row Expand"><input name='name' placeholder={nameStr} value={inputName} maxLength={20} style={{width:'100%'}} onChange={(e) => setInputName(e.target.value)} /></section>
            <section className="Row Expand"><input name='email' placeholder={emailStr} value={inputEmail} maxLength={70} style={{width:'100%'}} onChange={(e) => setInputEmail(e.target.value)} /></section>
            <section className="Row Expand"><input name='cell' placeholder={mobileStr} value={inputCell} maxLength={15} style={{width:'100%'}} onChange={(e) => setInputCell(e.target.value)} /></section>
            <section className="Row Expand"><textarea name='msg' placeholder={msgStr} value={inputMsg} maxLength={500} style={{width:'100%', height:'100px'}} onChange={(e) => setInputMsg(e.target.value)} /></section>
            <div className="Button" style={{width:'70px'}} onClick={handleSubmit}>{sendStr}</div>
            <br/>
            <div className="SubHeader">{response==''?'':(response=='ok'?msgSentStr:(response=='sending'?sendingStr:response))}</div>
          </section>
          
        </section>
      </div>
    </section>
    </div>
  );
}

export default Home;
